module.exports = __webpack_public_path__ + "static/img/qrcode.6f06a5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode.jpg
// module id = TUKC
// module chunks = 10